import React from "react";
import { Table } from "reactstrap";
import { Quotation } from "features/Quotations/types/quotation.types";
import { formatCurrency } from "utils/currency";
import { QuotationItemTypeLabelMap } from "features/Quotations/constants/quotation.constants";
import {
  quotationItemsSubtotal,
  quotationLineAmount,
} from "features/Quotations/utils/quotationItem.utils";

type Props = {
  record: Quotation;
};

export default function QuotationMaterialsPricingTab({ record }: Props) {
  const subTotal = quotationItemsSubtotal(record.items);

  return (
    <>
      <div className="table-responsive table-accordion">
        <Table className="table-nowrap align-middle mb-0">
          <thead className="table-light text-muted">
            <tr>
              <th scope="col">Type</th>
              <th scope="col">Description</th>
              <th scope="col">Unit</th>
              <th scope="col" className="text-end">
                Qty
              </th>
              <th scope="col" className="text-end">
                Rate
              </th>
              <th scope="col" className="text-end">
                Amount
              </th>
            </tr>
          </thead>
          <tbody>
            {record.items?.length ? (
              record.items.map((item, key) => {
                const line = quotationLineAmount(item);
                return (
                  <tr key={item.id ?? `${item.description}-${key}`}>
                    <td className="text-muted">
                      {QuotationItemTypeLabelMap[item.type] ?? item.type}
                    </td>
                    <td>
                      <span
                        className="text-body fw-medium"
                        style={{ whiteSpace: "pre-wrap" }}
                      >
                        {item.description?.trim() || "—"}
                      </span>
                    </td>
                    <td className="text-muted">{item.unit || "—"}</td>
                    <td className="text-end">{item.quantity}</td>
                    <td className="text-end">
                      {formatCurrency(Number(item.rate))}
                    </td>
                    <td className="text-end">{formatCurrency(line)}</td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={6} className="text-muted py-4">
                  No line items on this quotation.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <div className="table-responsive table-accordion mt-4">
        <Table className="table-borderless align-middle mb-0">
          <tbody>
            <tr className="table-active">
              <th scope="row">Total</th>
              <td className="text-end">
                <span className="fw-semibold fs-15">
                  {formatCurrency(subTotal)}
                </span>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </>
  );
}
